<template>
  <div id="rectificationTime" style="min-height: calc(100% - 130px);min-width: 900px;position: relative;overflow: hidden;">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/systemSetupList/systemSetup' }">系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>违规整改时间</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="height: 28px;line-height: 28px;margin: 20px;">
      <div class="dianDiv" style="float: left;">
        <div class="iconDiv">
          .
        </div>
        响应违规时间
      </div>
      <div style="float: right;">
        <el-button type="text" @click="compile" v-show="compileShow" style="margin-right: 10px;">编 辑</el-button>
        <el-button type="text" @click="sure" v-show="sureShow" style="margin-right: 10px;">确 定</el-button>
        <el-button type="text" @click="noSure" v-show="sureShow">取 消</el-button>
      </div>
    </div>
    <div class="page" style="clear: both;border-radius: 12px;">
      <el-row>
        <el-col :span="24">
          <div class="dianDiv" style="font-size: 14px;font-weight: 600;">
            初次响应时间设置
          </div>
          <div style="margin-top: 16px;">
            <el-radio v-model="countTime" label="1" :disabled="showTrue">单个时间</el-radio>
            <el-radio v-model="countTime" label="2" :disabled="showTrue">两个时间</el-radio>
          </div>
          <div class="recDiv"  v-if="countTime == 2">
            <div>
              通知整改后，店铺/经销商可在
            </div>
            <div style="margin: 0 5px 0 5px;">
              <el-input @blur="isNum(responseTime)" :disabled="showTrue" v-model="responseTime" style="width: 100px;" size="small" type="number"></el-input>
            </div>
            <div>
              分钟内进行响应整改或申诉。
            </div>
          </div>
          <div class="recDiv">
            <div style="color: red;">
              *
            </div>
            <div>
              通知整改后，店铺/经销商需要在
            </div>
            <div style="margin: 0 5px 0 5px;">
              <el-input @blur="isNum(closingTime)" :disabled="showTrue" v-model="closingTime" style="width: 100px;" size="small" type="number"></el-input>
            </div>
            <div>
              分钟内进行响应整改或申诉，超时未响应，违规信息处理流程自动完结。
            </div>
          </div>
          <div class="dianDiv" style="font-size: 14px;font-weight: 600;margin-top: 16px;">
            申诉不合理二次响应整改时间设置
          </div>
          <div class="recDiv">
            <div style="color: red;">
              *
            </div>
            <div>
              初次申诉评定结果为不合理，店铺/经销商需要在
            </div>
            <div style="margin: 0 5px 0 5px;">
              <el-input @blur="isNum(secondResponseTime)" :disabled="showTrue" v-model="secondResponseTime" style="width: 100px;" size="small" type="number"></el-input>
            </div>
            <div>
              分钟内进行二次响应整改，超时未响应整改，违规信息处理流程自动完结。
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="height: 28px;line-height: 28px;margin: 20px;">
      <div class="dianDiv" style="float: left;">
        <div class="iconDiv">
          .
        </div>
        违规信息手动处理与自动扣分设置
      </div>
    </div>
    <div class="page" style="clear: both;border-radius: 12px;display: flex;">
      <div class="dianDiv" style="font-size: 14px;font-weight: 600;margin-right: 120px;">
        违规信息自动化扣分处理
      </div>
      <el-switch
        v-model="elSwitch"
        active-color="#13ce66"
        inactive-color="#ff4949"
        @change="updateAutoDeduct">
      </el-switch>
    </div>

    <div style="height: 28px;line-height: 28px;margin: 20px;">
      <div class="dianDiv" style="float: left;">
        <div class="iconDiv">
          .
        </div>
        请选择进入信用积分扣分流程手动扣分的各类结果情况
      </div>
      <div style="float: right;">
        <el-button type="text" @click="pointcompile" v-show="pointcompileShow" style="margin-right: 10px;" :disabled="!elSwitch">编 辑</el-button>
        <el-button type="text" @click="pointsure" v-show="pointsureShow" style="margin-right: 10px;">确 定</el-button>
        <el-button type="text" @click="pointnoSure" v-show="pointsureShow">取 消</el-button>
      </div>
    </div>

    <div class="page" style="clear: both;border-radius: 12px;">
      <div class="dianDiv" style="font-size: 14px;">
      </div>
      <el-row style="margin-top: 16px;border-bottom: 1px solid #EBEEF5;padding: 16px 16px;background: #f3f7ff;">
        <el-col :span="20" v-if="!elSwitch">
          各类结果情况
        </el-col>
        <el-col :span="4" v-if="!elSwitch">
          扣分情况
        </el-col>
        <el-col :span="15" v-if="elSwitch">
          各类结果情况
        </el-col>
        <el-col :span="4" v-if="elSwitch">
          扣分情况
        </el-col>
        <el-col :span="5" v-if="elSwitch">
          扣分分值
        </el-col>
      </el-row>
      <el-row style="margin-top: 16px;border-bottom: 1px solid #EBEEF5;padding-bottom: 16px;"  v-for="(item,index) in elcolData">
        <el-col :span="elSwitch ? 15 : 20" v-if="item.key.indexOf('分时自动扣分处理') != -1">
          超过
         <el-input v-model="exceedPoint" placeholder="请输入≥0的数值" size="mini" style="width: 130px;" :disabled="pointDisabled" v-if="checkedData.indexOf(item.value) != -1"></el-input>
         <span v-else>
           {{exceedPoint}}
         </span>
         分时自动扣分处理
        </el-col>
        <el-col :span="elSwitch ? 15 : 20" v-else>
         {{item.key}}
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="checkedShow[index]" @change="elcolValue(item,index)" :disabled="pointDisabled">
            <span style="color: white;">
              {{item.value}}
            </span>
          </el-checkbox>
        </el-col>
        <el-col :span="5" v-if="elSwitch">
          <el-input v-model="item.elInput" placeholder="请输入≥0的数值" size="mini" :disabled="pointDisabled" v-if="checkedData.indexOf(item.value) != -1"></el-input>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        pointcompileShow: true,
        pointsureShow: false,
        pointDisabled: true,
        elcolData: [],
        checkedShow: [],
        checkedData: [],
        xRadio: '1',
        elSwitch: true,
        countTime: '1',
        responseTime: 60,
        secondResponseTime: 30,
        closingTime: 30,
        judge: '',
        sureShow: false,
        compileShow: true,
        showTrue: true,
        form: {
          name: '',
          desc: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入总分值', trigger: 'blur' },
          ]
        },
        exceedPoint: 0
      }
    },
    mounted() {
      this.selectViolationSetting()
      this.getReportResult()
    },
    methods: {
      inputBlur() {
        console.log(1231231)
      },
      getList() {
        fetch({
          url: "hcm/illegalAuto/getList",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.checkedData = []
            for (let a in this.elcolData) {
              for (let b in res.data) {
                if (this.elcolData[a].value == res.data[b].result) {
                  this.checkedData.push(res.data[b].result)
                  this.elcolData[a].elInput = res.data[b].points
                  this.checkedShow[a] = true
                }
              }
            }
            console.log(this.checkedData)

          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      // 违规信息自动化扣分处理
      updateAutoDeduct() {
        let num
        if (this.elSwitch == true) {
          num = 1
        } else {
          num = 0
        }
        let params = {
          autoDeduct: num
        }
        fetch({
          url: "/hcm/cus/updateAutoDeduct",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.$message({
              message: res.data,
              type: 'success'
            });
            this.selectViolationSetting()
          }
        })
      },
      // 信用积分扣分流程手动扣分的各类结果情况
      getReportResult() {
        fetch({
          url: "hcm/hcmReport/getReportResult",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.elcolData = []
            this.checkedData = []
            for(let a in res.data) {
              if (res.data[a].value == 'Y8') {
                this.exceedPoint = res.data[a].key.split('超过')[1].split('分时自动扣分处理')[0]
                console.log(this.exceedPoint)
              }
              this.elcolData.push({
                key: res.data[a].key,
                value: res.data[a].value,
                elInput: 0,
              })
              this.checkedData.push(res.data[a].value)
            }
            console.log(this.checkedData)
            this.getList()
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      // 多选数据处理
      elcolValue(item,index) {
        if (this.checkedShow[index] == true) {
          this.$set(this.checkedShow,index,true);
          this.checkedData.push(item.value)
        } else {
          this.$set(this.checkedShow,index,false);
          for (let a in this.checkedData) {
            if (this.checkedData[a] == item.value) {
              this.checkedData.splice(a,1)
            }
          }
        }
        this.$forceUpdate()
      },
      // 填完验证
      isNum(e) {
        if (this.isInteger(e) == false) {
          this.$message({
            message: '请输入大于0的整数！',
            type: 'warning'
          });
          return
        }
      },
      // 验证是否为整数
      isInteger(number){
        return number > 0 && String(number).split('.')[1] == undefined
      },
      //查询
      selectViolationSetting() {
        fetch({
          url: "/hcm/cus/selectViolationSetting",
          method: "post",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (data.closingTime) {
              this.closingTime = data.closingTime
            }
            if (data.responseTime) {
              this.responseTime = data.responseTime
            }
            if (data.secondResponseTime) {
              this.secondResponseTime = data.secondResponseTime
            }
            if (data.countTime) {
              this.countTime = data.countTime.toString()
            }
            if (data.autoDeduct == 1) {
              this.elSwitch = true
            } else {
              this.elSwitch = false
            }
          }
        })
      },
      //确定
      sure() {
        if (this.responseTime == '' || this.closingTime == '' || this.secondResponseTime == '') {
          this.$message({
            message: '请填写必填信息！',
            type: 'warning'
          });
          return;
        }
        if (this.isInteger(this.responseTime) == false || this.responseTime < 1
        || this.isInteger(this.closingTime) == false || this.closingTime < 1
        || this.isInteger(this.secondResponseTime) == false || this.secondResponseTime < 1) {
          this.$message({
            message: '请输入大于0的整数！',
            type: 'warning'
          });
          return;
        }
        if (this.countTime == 2) {
          if (this.closingTime < this.responseTime || this.closingTime == this.responseTime) {
            this.$message({
              message: '响应时间要大于' + this.responseTime + '分钟',
              type: 'warning'
            });
            return
          }
        }
        this.sureShow = false
        this.compileShow = true
        let params={
          responseTime: this.responseTime,
          secondResponseTime: this.secondResponseTime,
          countTime: this.countTime,
          closingTime: this.closingTime,
        }
        fetch({
          url: "/hcm/cus/updateViolationSetting",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.showTrue = true
            this.$message({
              message: res.data,
              type: 'success'
            });
            this.selectViolationSetting()
            this.getReportResult()
          }
        })
      },
      // 确认
      pointsure() {
        let hcmIllegalAutosList = []
        for (let a in this.elcolData) {
          for (let b in this.checkedData) {
            if (this.checkedData[b] == this.elcolData[a].value) {
              hcmIllegalAutosList.push({
                result: this.elcolData[a].value,
                onOff: 1,
                points: Number(this.elcolData[a].elInput),
              })
            }
          }
        }
        for (let b in hcmIllegalAutosList) {
          if (hcmIllegalAutosList[b].result == 'Y8') {
            hcmIllegalAutosList[b].exceedPoint = this.exceedPoint
          }
        }
        fetch({
          method: 'POST',
  				url: 'hcm/illegalAuto/save',
  				data: JSON.stringify(hcmIllegalAutosList),
  				headers: {
  					'Content-Type': 'application/json'
  				}
        }).then(result => {
          let res = result
          if(res.status == '10000'){
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.pointsureShow = false
            this.pointcompileShow = true
            this.pointDisabled = true
          }
        })
      },
      pointcompile() {
        this.pointsureShow = true
        this.pointcompileShow = false
        this.pointDisabled = false
      },
      pointnoSure() {
        this.pointsureShow = false
        this.pointcompileShow = true
        this.pointDisabled = true
      },
      // 取消
      noSure() {
        this.sureShow = false
        this.compileShow = true
        this.showTrue = true
        this.selectViolationSetting()
      },
      // 编辑
      compile() {
        this.showTrue = false
        this.sureShow = true
        this.compileShow = false
      },
    }
  }
</script>
<style scoped lang="scss">
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .iconDiv {
    width: 5px;
    background-color: #333333;
    margin-right: 10px;
    height: 21px;
    margin-top: 4px;
  }
</style>
<style lang="scss">
#rectificationTime {
  .recDiv {
    font-size: 14px;
    color: #666;
    display: flex;
    margin-top: 16px;
    height: 32px;
    line-height: 32px;
  }
  .dianDiv {
    font-size: 18px;
    color: #333333;
    display: flex;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .el-button--primary2 {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary2:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #bda571;
    background: #bda571;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #606266;
  }
}
</style>
